<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="100px">
			<h1>Register</h1>
			<hr>
			<el-form-item label="First name:">
				<el-input @input="$v.credentials.first_name.$touch()" placeholder="Your first name" type="text" v-model.trim="credentials.first_name" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.first_name.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.first_name.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.first_name.minLength">First Name must have at least {{$v.credentials.first_name.$params.minLength.min}} letters.</span>
				</span>
			</el-form-item>

			<el-form-item label="Last name:">
				<el-input @input="$v.credentials.last_name.$touch()" placeholder="Your last name" type="text" v-model.trim="credentials.last_name" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.last_name.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.last_name.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.last_name.minLength">Last Name must have at least {{$v.credentials.last_name.$params.minLength.min}} letters.</span>
				</span>
			</el-form-item>

			<el-form-item label="Location:">
				<el-input @input="$v.credentials.location.$touch()" placeholder="Your location" type="text" v-model.trim="credentials.location" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.location.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.location.required">Field is required.</span>
				</span>
			</el-form-item>

			<el-form-item label="Email:">
				<el-input @input="$v.credentials.email.$touch()" placeholder="Your email" type="email" v-model.trim="credentials.email" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.email.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.email.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.email.email">Must be a valid email.</span>
				</span>
			</el-form-item>

			<el-form-item label="VIN Number:">
				<el-input @input="$v.credentials.vin_chassis_no.$touch()" placeholder="Your first name" type="text" v-model.trim="credentials.vin_chassis_no" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.vin_chassis_no.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.vin_chassis_no.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.vin_chassis_no.minLength">VIN Number must have at least {{$v.credentials.vin_chassis_no.$params.minLength.min}} letters.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.vin_chassis_no.alphaNum">VIN Number can only container letters and numbers.</span>
				</span>
			</el-form-item>

			<el-form-item label="Vehicle model:">
				<el-select v-model="credentials.vehicle_model" :disabled="app.isLoading">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span v-if="$v.credentials.vehicle_model.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.vehicle_model.required">Field is required.</span>
				</span>
			</el-form-item>

			<el-form-item :label="'Odometer Reading (' + credentials.units + '):'">
				<el-input-number :step="1" @input="$v.credentials.odometer_reading.$touch()" :disabled="app.isLoading" v-model.number="credentials.odometer_reading" min="0"></el-input-number>
				<span class="el-form-item__error" v-if="!$v.credentials.odometer_reading.required">Field is required.</span>
			</el-form-item>

			<el-form-item label="Currency:">
				<el-select v-model="credentials.currency" :disabled="app.isLoading">
					<el-option v-for="(symbol, iso) in app.currencySymbols" :key="iso" :label="iso + ' ('+ symbol +')'" :value="iso">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="Prefered Units:">
				<el-radio-group v-model="credentials.units" :disabled="app.isLoading">
					<el-radio label="km">Kilometers</el-radio>
					<el-radio label="miles">Miles</el-radio>
				</el-radio-group>
			</el-form-item>

			<el-form-item label="Password:">
				<el-input @input="$v.credentials.password.$touch()" placeholder="Password" type="password" v-model.trim="credentials.password" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.password.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.password.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.password.minLength">Email must have at least {{$v.credentials.password.$params.minLength.min}} characters.</span>
				</span>
			</el-form-item>

			<el-form-item label="Repeat Password:">
				<el-input @input="$v.credentials.repeatPassword.$touch()" placeholder="Password" type="password" v-model.trim="credentials.repeatPassword" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.repeatPassword.$error">
					<span class="el-form-item__error" v-if="!$v.credentials.repeatPassword.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.repeatPassword.sameAsPassword">Passwords must be identical.</span>
				</span>
			</el-form-item>
			<hr>
			<p>
				<el-button type="primary" @click="register()" :disabled="$v.$invalid || app.isLoading" :loading="app.isLoading">
					Register
				</el-button>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import {
	required,
	sameAs,
	minLength,
	email,
	alphaNum
} from "vuelidate/lib/validators";
import axios from "axios";
import { getToken } from "@/utils/auth";
import router from "@/router";
import store from "@/utils/store";
import { REGISTER_URL } from "@/config";

export default {
	name: "login",
	data() {
		return {
			app: store,
			credentials: {
				first_name: "",
				last_name: "",
				email: "",
				location: "",
				vin_chassis_no: "",
				vehicle_model: "Toyota Mirai",
				odometer_reading: 0,
				currency: "EUR",
				units: "km",
				password: "",
				repeatPassword: ""
			},
			options: [
				{
					value: "Toyota Mirai",
					option: "Toyota Mirai"
				},
				{
					value: "Hyundai ix35",
					option: "Hyundai ix35"
				},
				{
					value: "Honda Clarity",
					option: "Honda Clarity"
				},
				{
					value: "Symbio",
					option: "Symbio"
				},
				{
					value: "Other",
					option: "Other"
				}
			]
		};
	},
	validations: {
		credentials: {
			first_name: {
				required,
				minLength: minLength(3)
			},
			last_name: {
				required,
				minLength: minLength(3)
			},
			email: {
				required,
				email
			},
			location: {
				required
			},
			vin_chassis_no: {
				required,
				alphaNum,
				minLength: minLength(5)
			},
			vehicle_model: {
				required
			},
			odometer_reading: {
				required
			},
			password: {
				required,
				minLength: minLength(6)
			},
			repeatPassword: {
				required,
				sameAsPassword: sameAs("password")
			}
		}
	},
	methods: {
		getToken,
		register() {
			if (this.$v.$invalid) return;
			let _self = this;
			axios
				.post(REGISTER_URL, this.$data.credentials)
				.then(function(response) {
					router.push("/");
					return (_self.app.messages = [
						`Thank you for registering, ${response.data
							.first_name} ${response.data
							.last_name}! You can now login using the details you have just entered.`
					]);
				})
				.catch(function(error) {
					let response = error.response;
					if (response.status === 400) {
						return (_self.app.messages = response.data.errors);
					}
					router.push("/");
					return (_self.app.messages = [response.data.message]);
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
</style>



// WEBPACK FOOTER //
// Register.vue?4886cea7